/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CardComponent} from './card.component';
import {TooltipModule} from '../tooltip/tooltip.module';

@NgModule({
    declarations: [CardComponent],
    imports: [
        CommonModule,
        TooltipModule
    ],
    exports: [
        CardComponent
    ]
})
export class CardModule {
}
